module.exports = __webpack_public_path__ + "img/ocho-banner.8aec294a.jpg";